import { SxProps, Theme } from '@mui/material';

export const getCurrencyInputSxStyles = (
  currencySymbol?: string | null,
): SxProps<Theme> => {
  return {
    ...(!!currencySymbol && {
      '.MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
        pl: 2,
      },
    }),
  };
};
